import type { UnwrapNestedRefs } from "vue";
import { ElButton, ElRow, ElCol, ElForm, ElFormItem, ElMessage } from "element-plus";
import type { ColProps } from "element-plus";
import { reactive } from "vue";
import { ComponentConf, FormItemGroup, MemberComponentPropsFilter } from "./types";
import type { FormDataStateType, FormItemLayoutColType, FormRenderItemConfType, FormRenderItemOtherConfType, IsMemberValidResultType, MemberComponentType, RenderNodesType, TextNodeType, QuickFormUserRenderInterface, SubmitFormInterface, ResetFormInterface, SubmitSlotFormInterface } from "./types";
import type { QuickFormPropsType } from "./index";
import isArray from "lodash-es/isArray";
import isFunction from "lodash-es/isFunction";
import indexOf from "lodash-es/indexOf";
import isEqual from "lodash-es/isEqual";
import cloneDeep from "lodash-es/cloneDeep";
import { memberComponents } from "./config";
import { Component, ComponentOptions, h } from "vue";
import type { SetupContext, VNode } from "vue";
import isUndefined from "lodash-es/isUndefined";
import findIndex from "lodash-es/findIndex";
import type { FormItemRule } from "element-plus";
import { isObject } from "lodash-es";
import type { SubmitToSeverOperateType } from "../../commonMix/submitToServer/types";

function useRender(
  props: QuickFormPropsType,
  ctx:  SetupContext<any>,
  formDataState: UnwrapNestedRefs<FormDataStateType>,
  formRefs:any,
  submitForm:SubmitFormInterface,
  resetForm:ResetFormInterface,
  submitSlotForm:SubmitSlotFormInterface,
  submitMixResult: SubmitToSeverOperateType,
  initResetValueMap:any

): QuickFormUserRenderInterface {
  const formItemsRef: any = {};
  const getformItemsRef: any = (el: any, key: string) => {
    formItemsRef[key] = el;
  };
  const formRef: any = {};
  const getFormRef: any = (el: any ) => {
    formRef.entity = el;
  };

  function checkValueFormulaMap(formValue: any): void {
    Object.keys(formDataState.valueFormulaMap).map((key: string) => {
      if (typeof formDataState.valueFormulaMap[key] == "string") {
        let setText: string = formDataState.valueFormulaMap[key];
        const matchListKey: RegExpMatchArray | null = setText.match(/{\w*}/g);
        if (!matchListKey) return;
        matchListKey.map((setKey: string) => {
          const getValKey: string = setKey.replace(/{(\w*)}/g, "$1");
          setText = setText.replace(
            new RegExp(setKey, "g"),
            formValue[getValKey] ? formValue[getValKey] : "0"
          );
        });
        try {
          setText = setText.replace(/{(\w*)}/g, "0");
          // eslint-disable-next-line

          const result: any = new Function(`return ${setText}`)();
          formDataState.valueFormulaMap[key] = result;
        } catch (e) {
          console.log(e);
          console.log("解析错误");
        }
      }
    });
  }
  /**
   * 循环渲染表单项
   */
  function formRender(): RenderNodesType[] {
    let renderNodeArr: RenderNodesType[] = [];
    if (isArray(props.renderData) && isFunction(props.renderDataFilter)) {
      renderNodeArr = props
        .renderDataFilter(props.renderData, formDataState.formValue, ctx)
        .map(
          (
            item: FormRenderItemConfType<any> | FormRenderItemConfType<any>[],
            idx
          ) => {
            const setItem: FormRenderItemConfType<any> =
              transArrayToFormItemGroupConf(item);
            return filterFormItem(setItem, idx, props.renderData);
          }
        );
    }

    return renderNodeArr;
  }
  /**
   * 转换数组为group配置
   */
  function transArrayToFormItemGroupConf(
    item: FormRenderItemConfType<any> | FormRenderItemConfType<any>[]
  ): FormRenderItemConfType<any> {
    let setItem: FormRenderItemConfType<any>;
    if (isArray(item)) {
      const makeGroup: FormRenderItemConfType<FormItemGroup> = cloneDeep(
        props.baseGroupConf
      ) as FormRenderItemConfType<FormItemGroup>;
      makeGroup.childForm = item;
      setItem = makeGroup;
    } else {
      setItem = item;
    }
    return setItem;
  }
  /**
   * 判空表单项渲染，主要增加容错性
   */
  function renderEmpty(): RenderNodesType {
    return null;
  }
  /**
   * 判空表单项渲染，主要增加容错性
   */
  function defaultRender(
    NodeConf: FormRenderItemConfType<any>,
    idx: number
  ): string {
    return `无法找到${NodeConf.type}类型组件,${idx}`;
  }
  /**
   * 过滤表单项类型
   */
  function filterFormItem<T>(
    item: FormRenderItemConfType<T>,
    idx: number,
    parentList: any[]
  ): RenderNodesType {
    if (isEqual(item, {}) || isEqual(item, { inline: undefined })) {
      // 判断空类型
      return renderEmpty();
    }
    if(item.initResetValue&&item.name){
      initResetValueMap[item.name ]=item.initResetValue
    }
    let result: RenderNodesType = null;
    const isSlot: boolean = indexOf(["slot"], item.type) >= 0;
    const isGroup: boolean = indexOf(["group"], item.type) >= 0;
    if (
      !isSlot &&
      !isGroup &&
      item.valueFormula &&
      typeof item.name == "string"
    ) {
      formDataState.valueFormulaMap[item.name] = item.valueFormula;
    } // valueFormula用于后期关联表单值

    const { ...filterItem } = item;
    const isMemberValidResult: IsMemberValidResultType =
      isMemberComponentsValid(item.type);
    const NodeConf: FormRenderItemConfType<any> =
      isSlot || isGroup
        ? filterItem
        : prevResultItem(filterItem, isMemberValidResult);

    switch (true) {
      case isMemberValidResult.isMemberComponents: {
        // 表单成员项渲染
        result = memberComponentsRender(
          isMemberValidResult,

          NodeConf,
          idx
        );
        break;
      }
      case indexOf(["textNode"], item.type) >= 0: {
        const textNodeItem: FormRenderItemConfType<TextNodeType> = {
          text: "",
          ...item,
          type: "textNode",
        };

        // 占位文本
        result = textNodeItem.name
          ? formDataState.formValue[textNodeItem.name]
          : typeof textNodeItem.text != "undefined"
          ? textNodeItem.text
          : "";
        break;
      }
      case isSlot: {
        // 外部插槽
        result = slotRender(NodeConf, idx);
        break;
      }
      case isGroup: {
        // group渲染

        result = FormGroupRender(NodeConf, idx);

        break;
      }
      default: {
        // 默认类型
        result = defaultRender(NodeConf, idx);
        break;
      }
    }

    return isGroup || (isSlot && NodeConf.haveWrap === false)
      ? result
      : renderFieldWrap(
          {
            ...filterItem,
          },
          result,
          idx,
          parentList
        );
  }
  /**
   * 判断组件的props是否合规存在
   *
   * @memberof MagicForm
   */
  function componentsPropsFilter(setProps: any, component: ComponentConf): any {
    const resSetProps: any = {};
    const setPropsKeys: string[] = Object.keys(setProps);
    let componentPropsKeys: string[] = ["key"];

    // 假如props是数组类型的时候
    if (isArray(component.props)) {
      componentPropsKeys = componentPropsKeys.concat(component.props);
    } else if (isObject(component.props)) {
      const setComponentPropsKeys: string[] = Object.keys(component.props);
      componentPropsKeys = componentPropsKeys.concat(setComponentPropsKeys);
    }
    setPropsKeys.map((setPropKey: string): void => {
      componentPropsKeys.map((key: string) => {
        if (setPropKey == key) {
          resSetProps[key] = setProps[key];
        }
      });
    });
    return resSetProps;
  }
  /**
   * 判断是否是成员项组件
   *
   * @memberof MagicForm
   */
  function isMemberComponentsValid(type: string): IsMemberValidResultType {
    let isMemberComponents: boolean = false;
    let memberListIndex: number = -1;
    let memberType: string = "";
    memberComponents.map((conf: MemberComponentType, idx: number) => {
      if (!type) return;
      const findTypeIdx = indexOf(conf.type, type);
      if (findTypeIdx >= 0) {
        isMemberComponents = true;
        memberListIndex = idx;
        memberType = conf.type[findTypeIdx];
      }
    });
    return { isMemberComponents, memberListIndex, memberType };
  }
  /**
   * 表单项的固定前置方法。一些公用事件和属性的绑定
   *
   * @memberof MagicForm
   */

  function prevResultItem(
    item: FormRenderItemConfType<any>,
    isMemberValidResult: IsMemberValidResultType
  ): FormRenderItemConfType<any> {
    // eslint-disable-next-line
    const { name, rules, type, onChange, ...baseProps } = item;

    return item;
  }
  /**
   *成员项渲染方法
   *
   * @memberof MagicForm
   */
  function memberComponentsRender(
    isMemberValidResult: IsMemberValidResultType,
    NodeConf: FormRenderItemConfType<any>,
    idx: number
  ): RenderNodesType {
    const memberComponentConf: MemberComponentType =
      memberComponents[isMemberValidResult.memberListIndex];
    const renderMemberComponent: ComponentConf = memberComponentConf.Component;

    if (!renderMemberComponent) {
      return "没有匹配的组件，请检查您的参数是否正确";
    }
    // eslint-disable-next-line

    NodeConf.name = NodeConf.name || "";

    const setDisabled: boolean = isUndefined(NodeConf.disabled)
      ? props.disabled
      : NodeConf.disabled; // 判断disabled
    const baseProps: FormRenderItemConfType<any> =
      typeof memberComponentConf.propsFilter == "function"
        ? memberComponentConf.propsFilter(
            NodeConf,
            NodeConf.name || "",
            props.modelValue,
            setDisabled
          )
        : NodeConf;

    // 通过解构过滤掉要设置的类型
    // eslint-disable-next-line
    const {
      type,
      componentType,
      style,
      childRender,
      rules,
      // eslint-disable-next-line no-unused-vars
      disabled,
      valueFormula,
      afterItemValueChange,
      fieldAttrs,
      slots,
      modelValueKey,
      ...filterBaseProps
    } = baseProps;

    let required = false;
    // 自动加上必填

    if (
      rules &&
      (rules as FormItemRule[]).length &&
      findIndex(rules as FormItemRule[], (o) => !!o.required) >= 0
    ) {
      required = true;
    } else if (rules && (rules as FormItemRule).required) {
      required = true;
    }
    const setName:string=baseProps.name?baseProps.name:""
    const setProps = {
      key: idx,
      type: componentType,
      required,

      ...filterBaseProps,
      disabled: setDisabled,
      // label: false,
      name:setName,
    };

    const finalSetProps = componentsPropsFilter(
      setProps,
      renderMemberComponent
    );
    const setModelValueKey: string = modelValueKey || "modelValue";
    const setModelEvent: string = `onUpdate:${setModelValueKey}`;
    return h(
      renderMemberComponent,
      {
        ref: (el: any) => getformItemsRef(el, `formItem_${setName}`),
        ...setProps.events,
        style:style||props.fieldContentStyle,
        ...(fieldAttrs || {}),
        ...finalSetProps,
        [setModelValueKey]: formDataState.formValue[setName],
        [setModelEvent]: ($$v: any) => {
          // formValue[name] != $$v
          if (
            !valueFormula &&
            formDataState.formValue[setName] != $$v
          ) {
            // 当设置值的关联规则的时候，不能填写

            formDataState.formValue[setName] = $$v;

            checkValueFormulaMap(formDataState.formValue);
            if (isFunction(afterItemValueChange)) {
              afterItemValueChange(setName, $$v, formDataState);
            }

            if (isFunction(baseProps.afterChange)) {
              baseProps.afterChange($$v, setName, formDataState);
            }
            ctx.emit("value-change",setName, $$v, formDataState); // 可以监听表单值改变事件
            ctx.emit("update:modelValue", formDataState.formValue); // 可以监听表单值改变事件
          }
        },
      },
      slots || childRender || undefined
    );
  }
  /**
   * 插槽渲染
   */
  function slotRender(
    NodeConf: FormRenderItemConfType<any>,
    idx: number
  ): RenderNodesType {
    let render: RenderNodesType;
    if (isFunction(NodeConf.render)) {
      render = NodeConf.render(formDataState.formValue);
    } else if (
      NodeConf.renderHtml &&
      NodeConf.renderHtml.html &&
      NodeConf.renderHtml.attrs
    ) {
      render = (
        <div
          {...{ ...NodeConf.renderHtml.attrs, style: NodeConf.renderHtml.style }}
          innerHTML={NodeConf.renderHtml.html}
        />
      );
    } else {
      render = NodeConf.render || null;
    }
    return render;
  }

  /*
组渲染方法
*/
  function FormGroupRender(
    NodeConf: FormRenderItemConfType<any>,
    idx: number
  ): RenderNodesType {
    let result = null;

    const FormGroupBox = NodeConf.GroupBox ? NodeConf.GroupBox : ElRow;

    const finalSetProps = componentsPropsFilter(NodeConf, FormGroupBox);
    result = h(
      FormGroupBox,
      {
        listKey: "idx",

        ...finalSetProps,
        className: NodeConf.className ? NodeConf.className : "",
      },
      [
        NodeConf.childForm.map(
          (groupItem: FormRenderItemConfType<any>, groupIdx: number) => {
            return filterFormItem(groupItem, groupIdx, NodeConf.childForm);
          }
        ),
      ]
    );

    if (NodeConf.wrapRender) {
      result = NodeConf.wrapRender(result, formDataState.formValue);
    }
    return result;
  }

  function renderFieldWrap(
    itemConf: FormRenderItemConfType<any>,
    result: RenderNodesType,
    idx: number,
    parentList: any[]
  ):RenderNodesType {
    /* eslint-disable */
    let {
      layoutCol,

      rules,
      label,
      prop,
      name,

      nowrap,
      onlyFormItem,
      fieldStyle,
      formItemContentRender,
      formItemProps,
      labelWidth,
      labelLeft, // 表单左边的插槽
      labelRight, // 表单右边的插槽
      ...otherProps
    } = itemConf;
    /* eslint-enable */
    const setOnlyFormItem:boolean=!!onlyFormItem||!!props.onlyFormItem;
    const propsFieldStyle = cloneDeep(props.fieldStyle);
    const setPropsFieldStyle=isObject(propsFieldStyle) ? propsFieldStyle : {}
    const setFormFieldStyle = Object.assign({}, setPropsFieldStyle,(fieldStyle && isObject(fieldStyle) ? fieldStyle : {}))
    
   
    layoutCol = layoutCol || 24;
    const setLayoutCol: FormItemLayoutColType =
      typeof layoutCol == "number"
        ? {
            span: layoutCol,
          }
        : layoutCol;
    let isRequired: boolean = false;

    if (
      rules &&
      isArray(rules) &&
      findIndex(rules as FormItemRule[], { required: true }) >= 0
    ) {
      isRequired = true;
    } else if (rules && isObject(rules) && (rules as FormItemRule).required) {
      isRequired = true;
    }
    const willSetFieldProps = {
      label: label,
      prop: prop || name,
      required: isRequired,
      rules,
      labelWidth,
      ...formItemProps,
    };

    formItemContentRender = isFunction(formItemContentRender)
      ? formItemContentRender
      : props.formItemContentRender;
    const finalSetFormItemProps = componentsPropsFilter(
      willSetFieldProps,
      ElFormItem
    );
    const childRenderVNodes: RenderNodesType[] = [
      formItemContentRender(
        result,
        itemConf,
        formDataState.formValue,
        idx,
        parentList
      ),
    ];
    if (labelLeft) {
      childRenderVNodes.unshift(labelLeft);
    }
    if (labelRight) {
      childRenderVNodes.unshift(labelRight);
    }
    if (nowrap) {
      // 假如是nowrap类型的时候不用包裹el-form-item

      return h(
        "div",
        { 
          className: "nowrap-form-item",
          style:setFormFieldStyle,
         },
        { default: () => childRenderVNodes }
      );
    }
    if(setOnlyFormItem){
      return  h(
            ElFormItem,
            { style: setFormFieldStyle, ...finalSetFormItemProps },
            { default: () => childRenderVNodes }
      );
    }
    return h(ElCol, setLayoutCol, {
      default: () =>
        h(
          ElFormItem,
          { style: setFormFieldStyle, ...finalSetFormItemProps },
          { default: () => childRenderVNodes }
        ),
    });
  }

  function elFormRender(): RenderNodesType {
    const validate =  formRefs.elForm ?  formRefs.elForm.validate : undefined;
    const formAttrs = {
      ...props.formProps,
      size: props.formSize || undefined,
      model: formDataState.formValue,
    };

    const buttonGroupColConfig: any = props.buttonGroupColConfig
      ? props.buttonGroupColConfig
      : {};
    const { style, ...otherBtnColAttrs } = buttonGroupColConfig;
    const finalSetFormProps = componentsPropsFilter(formAttrs, ElForm);
    return !props.isSlotRender ? (
      <ElForm {...finalSetFormProps} ref={(el:any)=>{ formRefs.elForm=el; }}>
        {props.onlyFormItem?
        (<div class="only-form-wrap">
          {formRender()}
          {props.buttonGroupRender
          ? props.buttonGroupRender(
              formDataState.formValue,
              submitForm,
              resetForm,
              validate,
              formDataState,
              submitMixResult,
              props
            )
          : []}</div>):(
        <ElRow gutter={20}>
          {formRender()}
          {props.buttonGroupColConfig ? (
            <ElCol class="button-col-wrap" {...otherBtnColAttrs} style={style}>
              {props.buttonGroupRender
                ? props.buttonGroupRender(
                    formDataState.formValue,
                    submitForm,
                    resetForm,
                    validate,
                    formDataState,
                    submitMixResult,
                    props
                  )
                : []}
            </ElCol>
          ) : null}
        </ElRow>)}
      </ElForm>
    ) : (
      ctx.slots.default?ctx.slots.default({
        formValue: formDataState.formValue,
        submitForm: submitSlotForm,
        getFormRef,
      }):null
    );
  }
  return {
    elFormRender,
    formRef,
    formItemsRef,
  };
}
export default useRender;
